import { Form } from 'antd';
import type React from 'react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigateToNextStep } from '../../hooks/useNavigateToNextStep';

import { v4 as uuidV4 } from 'uuid';
import { StorageKeys } from '../../../api/constants';
import ContinueButton from '../../../components/continueButton/ContinueButton';
import { initTracerSetup } from '../../../utils/tracer';
import { STEPS } from '../../constants';
import useStartTenantSetup from '../../hooks/useStartTenantSetup';

const TRANSLATION_ROOT = 'setup.content';

const SetupLandingPage: React.FC = () => {
  const { t } = useTranslation();
  const navigateToNextStep = useNavigateToNextStep();
  const [dpaNoActionNeeded, setDpaNoActionNeeded] = useState(false);
  const [isLoading, setLoading] = useState(false);

  // Generate and store workflowId in sessionStorage
  useEffect(() => {
    localStorage.clear();
    sessionStorage.clear();
    const workflowId = uuidV4();
    initTracerSetup(workflowId);
    sessionStorage.setItem(StorageKeys.WORKFLOW_ID, workflowId);
    console.debug('[Setup] workflowId:', workflowId);
  }, []);

  const { mutate, isPending } = useStartTenantSetup({ setLoading, setDpaNoActionNeeded });

  // Trigger the mutation when the component mounts
  useEffect(() => {
    mutate();
  }, [mutate]);

  // Handle form submission and navigation
  const onSubmit = () => {
    if (dpaNoActionNeeded) {
      navigateToNextStep(STEPS.ORG_INFO);
    } else {
      navigateToNextStep(STEPS.DATA_PROCESSING_ADDENDUM);
    }
  };

  return (
    <>
      <div>
        <p className="subtitle">{t(`${TRANSLATION_ROOT}.description`)}</p>
      </div>
      <div>
        <span className="primary-body">
          <ul>
            <li>{t(`${TRANSLATION_ROOT}.list-content-1`)}</li>
            <li>{t(`${TRANSLATION_ROOT}.list-content-2`)}</li>
            <li>{t(`${TRANSLATION_ROOT}.list-content-3`)}</li>
            <li>{t(`${TRANSLATION_ROOT}.list-content-4`)}</li>
            <li>{t(`${TRANSLATION_ROOT}.list-content-5`)}</li>
          </ul>
        </span>
      </div>
      <div style={{ marginTop: '2rem' }}>
        <Form>
          <ContinueButton
            autoFocus
            disabled={isPending || isLoading}
            data-testid="proceed-btn"
            label={t(`${TRANSLATION_ROOT}.next-button`)}
            onClick={onSubmit}
            type="primary"
          />
        </Form>
      </div>
    </>
  );
};

export default SetupLandingPage;
